declare namespace $ {

	type $shm_hitalama_map_widget_float_page__name_shm_hitalama_map_widget_float_form_custom_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form_custom['title'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_page['name'] >
	>
	type $shm_hitalama_map_widget_float_page__content_shm_hitalama_map_widget_float_form_custom_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form_custom['page_content'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_page['content'] >
	>
	type $mol_form_field__name_shm_hitalama_map_widget_float_form_custom_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form_custom['field_name'] >
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__bid_shm_hitalama_map_widget_float_form_custom_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form_custom['field_bid'] >
		,
		ReturnType< $mol_form_field['bid'] >
	>
	type $mol_form_field__Content_shm_hitalama_map_widget_float_form_custom_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form_custom['Field_content'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $shm_hitalama_form_submit__title_shm_hitalama_map_widget_float_form_custom_6 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_form_submit['title'] >
	>
	type $shm_hitalama_form_submit__click_shm_hitalama_map_widget_float_form_custom_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form_custom['submit'] >
		,
		ReturnType< $shm_hitalama_form_submit['click'] >
	>
	type $shm_hitalama_form_submit__enabled_shm_hitalama_map_widget_float_form_custom_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form_custom['submit_allowed'] >
		,
		ReturnType< $shm_hitalama_form_submit['enabled'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_form_custom_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_form_custom_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form_custom['clear_ask'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_major__title_shm_hitalama_map_widget_float_form_custom_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_shm_hitalama_map_widget_float_form_custom_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form_custom['clear_confirm'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_form_custom_13 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_form_custom_14 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form_custom['clear_cancel'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_form_custom_15 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_row__sub_shm_hitalama_map_widget_float_form_custom_16 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_row['sub'] >
	>
	type $mol_status__message_shm_hitalama_map_widget_float_form_custom_17 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form_custom['submit_result'] >
		,
		ReturnType< $mol_status['message'] >
	>
	type $mol_status__style_shm_hitalama_map_widget_float_form_custom_18 = $mol_type_enforce<
		({ 
			'color': string,
		}) 
		,
		ReturnType< $mol_status['style'] >
	>
	type $mol_form__form_fields_shm_hitalama_map_widget_float_form_custom_19 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form_custom['form_fields'] >
		,
		ReturnType< $mol_form['form_fields'] >
	>
	type $mol_form__buttons_shm_hitalama_map_widget_float_form_custom_20 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form_custom['buttons'] >
		,
		ReturnType< $mol_form['buttons'] >
	>
	type $shm_hitalama_map_widget_float_form_string__value_shm_hitalama_map_widget_float_form_custom_21 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form_custom['field_value'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_form_string['value'] >
	>
	type $mol_textarea__value_shm_hitalama_map_widget_float_form_custom_22 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form_custom['field_value'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $shm_date_view__value_shm_hitalama_map_widget_float_form_custom_23 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form_custom['field_value'] >
		,
		ReturnType< $shm_date_view['value'] >
	>
	type $mol_number__value_shm_hitalama_map_widget_float_form_custom_24 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form_custom['field_number'] >
		,
		ReturnType< $mol_number['value'] >
	>
	type __shm_hitalama_map_widget_float_form_custom_25 = $mol_type_enforce<
		Parameters< $shm_hitalama_map_widget_float_form_custom['period_str'] >[0]
		,
		Parameters< $shm_hitalama_map_widget_float_form_custom['Period'] >[0]
	>
	type $shm_period__period_shm_hitalama_map_widget_float_form_custom_26 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form_custom['field_value'] >
		,
		ReturnType< $shm_period['period'] >
	>
	type $shm_hitalama_file_attach__files_shm_hitalama_map_widget_float_form_custom_27 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form_custom['field_files'] >
		,
		ReturnType< $shm_hitalama_file_attach['files'] >
	>
	type $shm_hitalama_file_attach__value_shm_hitalama_map_widget_float_form_custom_28 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form_custom['field_value'] >
		,
		ReturnType< $shm_hitalama_file_attach['value'] >
	>
	type $shm_hitalama_file_attach_pb__value_shm_hitalama_map_widget_float_form_custom_29 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form_custom['field_value'] >
		,
		ReturnType< $shm_hitalama_file_attach_pb['value'] >
	>
	type $shm_hitalama_file_attach_pb__map_id_shm_hitalama_map_widget_float_form_custom_30 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form_custom['pb_map_id'] >
		,
		ReturnType< $shm_hitalama_file_attach_pb['map_id'] >
	>
	type $shm_hitalama_file_attach_pb__widget_id_shm_hitalama_map_widget_float_form_custom_31 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form_custom['pb_widget_id'] >
		,
		ReturnType< $shm_hitalama_file_attach_pb['widget_id'] >
	>
	type $shm_hitalama_file_attach_pb__field_name_shm_hitalama_map_widget_float_form_custom_32 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form_custom['field_name'] >
		,
		ReturnType< $shm_hitalama_file_attach_pb['field_name'] >
	>
	type $shm_hitalama_map_widget_float_table_relation_atom__value_shm_hitalama_map_widget_float_form_custom_33 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form_custom['field_value'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_relation_atom['value'] >
	>
	type $shm_hitalama_map_widget_float_table_relation_atom__dictionary_shm_hitalama_map_widget_float_form_custom_34 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form_custom['field_link_options'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_relation_atom['dictionary'] >
	>
	type $shm_hitalama_map_widget_float_table_relation_atom__active_shm_hitalama_map_widget_float_form_custom_35 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form_custom['field_relation_active'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_relation_atom['active'] >
	>
	type $shm_hitalama_map_widget_float_table_relation_atom__open_shm_hitalama_map_widget_float_form_custom_36 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form_custom['field_relation_open'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_relation_atom['open'] >
	>
	type $shm_hitalama_map_widget_float_table_relation_atom__create_shm_hitalama_map_widget_float_form_custom_37 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form_custom['field_relation_create'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_relation_atom['create'] >
	>
	type $shm_hitalama_map_widget_float_table_relation_list__value_shm_hitalama_map_widget_float_form_custom_38 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form_custom['field_list_value'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_relation_list['value'] >
	>
	type $shm_hitalama_map_widget_float_table_relation_list__dictionary_shm_hitalama_map_widget_float_form_custom_39 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form_custom['field_link_options'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_relation_list['dictionary'] >
	>
	type $shm_hitalama_map_widget_float_table_relation_list__active_shm_hitalama_map_widget_float_form_custom_40 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form_custom['field_relation_active'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_relation_list['active'] >
	>
	type $shm_hitalama_map_widget_float_table_relation_list__open_shm_hitalama_map_widget_float_form_custom_41 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form_custom['field_relation_open'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_relation_list['open'] >
	>
	type $shm_hitalama_map_widget_float_table_relation_list__create_shm_hitalama_map_widget_float_form_custom_42 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form_custom['field_relation_create'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_relation_list['create'] >
	>
	type $mol_select__value_shm_hitalama_map_widget_float_form_custom_43 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form_custom['field_value'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__dictionary_shm_hitalama_map_widget_float_form_custom_44 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form_custom['field_select_dictionary'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_select__Filter_shm_hitalama_map_widget_float_form_custom_45 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_select['Filter'] >
	>
	type $mol_textarea__value_shm_hitalama_map_widget_float_form_custom_46 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form_custom['field_json'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_textarea__hint_shm_hitalama_map_widget_float_form_custom_47 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_textarea['hint'] >
	>
	type $mol_check_box__title_shm_hitalama_map_widget_float_form_custom_48 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_hitalama_map_widget_float_form_custom_49 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_form_custom['buttons_visible'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	export class $shm_hitalama_map_widget_float_form_custom extends $shm_hitalama_map_widget_float {
		page_content( ): readonly(any)[]
		Widget_page( ): $shm_hitalama_map_widget_float_page
		field_name( id: any): string
		field_bid( id: any): string
		Field_content( id: any): $mol_view
		Field( id: any): $mol_form_field
		form_fields( ): readonly(any)[]
		submit_allowed( ): ReturnType< ReturnType< $shm_hitalama_map_widget_float_form_custom['Form'] >['submit_allowed'] >
		submit( next?: any ): any
		Publish( ): $shm_hitalama_form_submit
		clear_ask( next?: any ): any
		Clear( ): $mol_button_minor
		clear_button_visible( ): readonly(any)[]
		clear_confirm( next?: any ): any
		Clear_confirm( ): $mol_button_major
		clear_cancel( next?: any ): any
		Clear_cancel( ): $mol_button_minor
		clear_confirm_visible( ): readonly(any)[]
		Clear_actions( ): $mol_view
		Actions( ): $mol_row
		submit_result( next?: string ): string
		Submit_result( ): $mol_status
		submit_result_visible( ): readonly(any)[]
		buttons( ): readonly(any)[]
		Form( ): $mol_form
		field_value( id: any, next?: any ): any
		String( id: any): $shm_hitalama_map_widget_float_form_string
		Textarea( id: any): $mol_textarea
		Date( id: any): $shm_date_view
		field_number( id: any, next?: number ): number
		Number( id: any): $mol_number
		period_str( id: any): ReturnType< ReturnType< $shm_hitalama_map_widget_float_form_custom['Period'] >['period_str'] >
		Period( id: any): $shm_period
		field_files( id: any, next?: readonly(any)[] ): readonly(any)[]
		File( id: any): $shm_hitalama_file_attach
		pb_map_id( ): string
		pb_widget_id( ): string
		File_pb( id: any): $shm_hitalama_file_attach_pb
		field_link_options( id: any): Record<string, any>
		field_relation_active( id: any): string
		field_relation_open( id: any, next?: string ): string
		field_relation_create( id: any, next?: any ): any
		Atom_link( id: any): $shm_hitalama_map_widget_float_table_relation_atom
		field_list_value( id: any, next?: readonly(string)[] ): readonly(string)[]
		List_link( id: any): $shm_hitalama_map_widget_float_table_relation_list
		field_select_dictionary( id: any): Record<string, any>
		Select( id: any): $mol_select
		field_json( id: any, next?: string ): string
		Json( id: any): $mol_textarea
		buttons_visible( next?: boolean ): boolean
		Buttons_visible( ): $mol_check_box
		controls( ): readonly(any)[]
		clear_asked( next?: boolean ): boolean
		custom( ): $shm_hitalama_map_widget_entity_form_custom
		Content_by_type( id: any): ({ 
			'any': ReturnType< $shm_hitalama_map_widget_float_form_custom['String'] >,
			'string': ReturnType< $shm_hitalama_map_widget_float_form_custom['String'] >,
			'textarea': ReturnType< $shm_hitalama_map_widget_float_form_custom['Textarea'] >,
			'date': ReturnType< $shm_hitalama_map_widget_float_form_custom['Date'] >,
			'number': ReturnType< $shm_hitalama_map_widget_float_form_custom['Number'] >,
			'period': ReturnType< $shm_hitalama_map_widget_float_form_custom['Period'] >,
			'file': ReturnType< $shm_hitalama_map_widget_float_form_custom['File'] >,
			'file_pb': ReturnType< $shm_hitalama_map_widget_float_form_custom['File_pb'] >,
			'atom_link': ReturnType< $shm_hitalama_map_widget_float_form_custom['Atom_link'] >,
			'list_link': ReturnType< $shm_hitalama_map_widget_float_form_custom['List_link'] >,
			'select': ReturnType< $shm_hitalama_map_widget_float_form_custom['Select'] >,
			'json': ReturnType< $shm_hitalama_map_widget_float_form_custom['Json'] >,
		}) 
		settings_content( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=custom.view.tree.d.ts.map